module.exports = __webpack_public_path__ + "img/coming-soon-dark.fb6b71df.svg";